import { DatePicker } from "@/common/components/ui/datePicker";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterStartDateHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  return (
    <DatePicker
      date={value}
      setDate={onChange}
      name="start_date"
      inputClassName="min-h-[52px] text-sm not-italic bg-white-200 text-white-800 rounded-md shadow-none"
    />
  );
}

export default DashboardFilterStartDateHiddenFilter;
